export { ReactComponent as SpacerObject } from './svgs/spacer-object.svg';
